import { Injectable } from '@angular/core';
import { ActionGetBlockchainStatus } from '@module-shared/actions/actions-blockchain';
import { BlockchainHttpService } from '@module-shared/services/blockchain-http/blockchain-http.service';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

export interface StateBlockchainStatus {
  isValid: boolean;
  loading: boolean;
  isDefault: boolean;
}

export interface StateBlockchain {
  readonly blockchainStatus: StateBlockchainStatus;
}

@State<StateBlockchain>({
  name: 'StateBlockchain',
  defaults: {
    blockchainStatus: {
      isValid: false,
      loading: false,
      isDefault: true
    }
  }
})
@Injectable()
export class StateBlockchainService {
  @Selector() static blockchainStatus(
    state: StateBlockchain
  ): StateBlockchainStatus {
    return state.blockchainStatus;
  }

  constructor(private blockchainService: BlockchainHttpService) {}

  @Action(ActionGetBlockchainStatus)
  onGetBlockchainStatus({
    getState,
    patchState
  }: StateContext<StateBlockchain>) {
    patchState({
      blockchainStatus: {
        ...getState().blockchainStatus,
        loading: true
      }
    });

    return this.blockchainService.getBlockchainStatus().pipe(
      tap((isValid) =>
        patchState({
          blockchainStatus: {
            ...getState().blockchainStatus,
            loading: false,
            isDefault: false,
            isValid
          }
        })
      ),
      catchError((e) => {
        patchState({
          blockchainStatus: {
            ...getState().blockchainStatus,
            loading: false
          }
        });

        return throwError(e);
      })
    );
  }
}
